module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filingInformation"
  }, [_c('group', {
    attrs: {
      "title": "个人信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "女方就诊卡",
      "value": _vm.cardValue
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "姓名",
      "value": _vm.nameValue
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "出生年月",
      "value": _vm.dateValue
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "联系电话",
      "value": _vm.tellValue
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.SFZValue
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "双方证件（所有证件需要完整拍摄，不可缺边缺角）"
    }
  }, [_c('div', {
    staticClass: "marryCertificate"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("双方结婚证 "), _c('span', {
    on: {
      "click": function($event) {
        _vm.noconfim('没有结婚证怎么办？', '可以使用大使馆证明等其他官方证明，请在结婚证上传处上传，单份证明请上传双份')
      }
    }
  }, [_vm._v("没有结婚证？")])]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, [_c('grid-item', {
    staticClass: "uploadClass"
  }, [_c('div', [(!_vm.marryImg) ? _c('img', {
    attrs: {
      "src": _vm.SLmarryimg
    },
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SLmarryimg)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marryImg) ? _c('i', {
    staticClass: "marry icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marryImg) ? _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.marryImgSrc)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.marryImgSrc,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v(_vm._s(_vm.contact.marryTxt))]), _vm._v(" "), (_vm.contact.marryTxt != '已通过审核') ? _c('div', {
    staticClass: "uploadBtn"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 2)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e()])])], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("双方身份证"), _c('span', {
    on: {
      "click": function($event) {
        _vm.noconfim('没有身份证怎么办？', '可以使用军官证、护照、台胞证、派出所证明等其他官方证明。')
      }
    }
  }, [_vm._v("没有身份证？")])]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, [_c('grid-item', {
    staticClass: "uploadClass"
  }, [_c('div', [(!_vm.SFZImgZ) ? _c('img', {
    attrs: {
      "src": _vm.SLsfzZimg
    },
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SLsfzZimg)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SFZImgZ) ? _c('i', {
    staticClass: "SFZZ icon-red  icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SFZImgZ) ? _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SFZImgSrcZ)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.SFZImgSrcZ,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("双方身份证正面")]), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v(_vm._s(_vm.contact.SFZZTxt))]), _vm._v(" "), (_vm.contact.SFZZTxt != '已通过审核') ? _c('div', {
    staticClass: "uploadBtn"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 0)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e()])]), _vm._v(" "), _c('grid-item', {
    staticClass: "uploadClass"
  }, [_c('div', [(!_vm.SFZImgF) ? _c('img', {
    attrs: {
      "src": _vm.SLsfzFimg
    },
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SLsfzFimg)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SFZImgF) ? _c('i', {
    staticClass: "SFZF icon-red icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SFZImgF) ? _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SFZImgSrcF)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.SFZImgSrcF,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("双方身份证反面")]), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v(_vm._s(_vm.contact.SFZFTxt))]), _vm._v(" "), (_vm.contact.SFZFTxt != '已通过审核') ? _c('div', {
    staticClass: "uploadBtn"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 1)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e()])])], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("双方合照")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, [_c('grid-item', {
    staticClass: "uploadClass"
  }, [_c('div', [(!_vm.groupphotoImg) ? _c('img', {
    attrs: {
      "src": _vm.SLgroupphotoimg
    },
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.SLgroupphotoimg)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.groupphotoImg) ? _c('i', {
    staticClass: "groupphoto icon-red icon iconfont icon-guanbi",
    on: {
      "click": function($event) {
        _vm.deleImgClick(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.groupphotoImg) ? _c('div', {
    staticClass: "imgloading",
    on: {
      "click": function($event) {
        _vm.diagClick(_vm.groupphotoImgSrc)
      }
    }
  }, [_c('span', [_c('inline-loading'), _vm._v("图片加载中")], 1), _vm._v(" "), _c('x-img', {
    staticClass: "ximg-demo",
    attrs: {
      "src": _vm.groupphotoImgSrc,
      "error-class": "ximg-error",
      "offset": -100,
      "container": "#vux_view_box_body"
    },
    on: {
      "on-success": _vm.Imgsuccess,
      "on-error": _vm.Imgerror
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v(_vm._s(_vm.contact.groupphotoTxt))]), _vm._v(" "), (_vm.contact.groupphotoTxt != '已通过审核') ? _c('div', {
    staticClass: "uploadBtn"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadChange($event, 3)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])]) : _vm._e()])])], 1)], 1)]), _vm._v(" "), _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    staticClass: "submitBtn",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("同意并申请")]), _vm._v(" "), _c('toast', {
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastTxt))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-filingInformation",
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.dialogSrc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#E64340",
      "border-radius": "45px",
      "z-index": "5001",
      "position": "absolute",
      "right": "-15px",
      "top": "-15px",
      "width": "40px",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-close-empty",
    staticStyle: {
      "fill": "#fff"
    },
    attrs: {
      "type": "ios-close-empty",
      "size": "40",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"
    }
  })])])]), _vm._v(" "), _c('confirm', {
    attrs: {
      "title": "提示"
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("该图片删除后将无法恢复，确认删除吗？")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351aab8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/selfHelpFilingProject/filingInformation.vue
// module id = xiVE
// module chunks = 5